import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.TERM_COLLECTION_LIST, { params: { ...payload } }),
    addTermCollection: payload => axios.post(HTTP.TERM_COLLECTION, payload),
    updateTermCollection: payload => axios.put(HTTP.TERM_COLLECTION, payload),
    deleteTermCollection: payload => axios.delete(HTTP.TERM_COLLECTION, { params: { ...payload } })
}
